import React from 'react';
import { Form, Button, Radio, Input } from 'antd';
import * as actions from '../../../store/actions/InterviewActions';
import { setSubmittedBy } from '../../../store/actions';
import { connect } from 'react-redux';
import { history } from '../../../index';
import { withTranslation } from 'react-i18next';
import analytics from '../../../services/analytics';

import styles from './FeedbackForm.scss';

class FeedbackForm extends React.Component {
  formRef = React.createRef();
  state = {
    isFormValid: false,
  };

  showSurveyCompletePage = async () => {
    await this.props.setSubmittedBy('interviewer');
    const interview_id = localStorage.getItem('interview_id');
    history.push(`/survey/interview/${interview_id}`);
  };

  handleFinish = values => {
    const data = {
      rating: values.rating,
      feedback: values.feedback,
    };

    // Track feedback submitted with rating
    const interviewId = localStorage.getItem('interview_id');
    analytics.trackFeedbackSubmitted(interviewId, values.rating);

    this.props.submitFeedback(data, this.showSurveyCompletePage);
  };

  handleFormChange = (_, allFields) => {
    const isValid = allFields.every(
      field => field.errors.length === 0 && field.value !== undefined && field.value !== '',
    );
    this.setState({ isFormValid: isValid });
  };

  render() {
    const { t } = this.props;

    return (
      <Form
        className={styles.form}
        ref={this.formRef}
        layout="vertical"
        onFinish={this.handleFinish}
        onFieldsChange={this.handleFormChange}
      >
        <Form.Item
          name="rating"
          label={t('feedback.rating.label')}
          className={styles['form-rating']}
          rules={[{ required: true, message: t('feedback.rating.validation_required') }]}
        >
          <Radio.Group>
            <Radio value={1}>{t('feedback.rating.options.never_hire')}</Radio>
            <Radio value={2}>{t('feedback.rating.options.not_inclined')}</Radio>
            <Radio value={3}>{t('feedback.rating.options.maybe')}</Radio>
            <Radio value={4}>{t('feedback.rating.options.inclined')}</Radio>
            <Radio value={5}>{t('feedback.rating.options.strong_hire')}</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          name="feedback"
          label={t('feedback.comment.label')}
          className={styles['form-feedback']}
          rules={[{ required: true, message: t('feedback.comment.validation_required') }]}
        >
          <Input.TextArea className={styles['form-feedback__textarea']} />
        </Form.Item>

        <Form.Item className={styles['form-button']}>
          <Button
            type="primary"
            htmlType="submit"
            disabled={!this.state.isFormValid}
          >
            {t('feedback.submit')}
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  submitFeedback: (data, callback) => dispatch(actions.submitFeedback(data, callback)),
  setSubmittedBy: value => dispatch(setSubmittedBy(value)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation('interview_container')(FeedbackForm));
